var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.8571 27.8571C24.7143 31.1 24.4857 35.1429 24.2143 44C32.4714 44 38.1714 43.9714 41.1143 41.1143C43.9714 38.1714 44 32.2 44 24.2143C35.1429 24.5 31.1 24.7143 27.8571 27.8571ZM4 24.2143C4 32.2 4.02857 38.1714 6.88571 41.1143C9.82857 43.9714 15.5286 44 23.7857 44C23.5 35.1429 23.2857 31.1 20.1429 27.8571C16.9 24.7143 12.8571 24.4857 4 24.2143ZM23.7857 4C15.5429 4 9.82857 4.02857 6.88571 6.88571C4.02857 9.82857 4 15.8 4 23.7857C12.8571 23.5 16.9 23.2857 20.1429 20.1429C23.2857 16.9 23.5143 12.8571 23.7857 4ZM27.8571 20.1429C24.7143 16.9 24.4857 12.8571 24.2143 4C32.4714 4 38.1714 4.02857 41.1143 6.88571C43.9714 9.82857 44 15.8 44 23.7857C35.1429 23.5 31.1 23.2857 27.8571 20.1429Z",
    fill: "#333333"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZen);
export default __webpack_public_path__ + "static/media/zen.dbe6510010ef79025d9a754bd7afa451.svg";
export { ForwardRef as ReactComponent };